<label (click)="expanded = !expanded">
    Filter by Units
    <ng-container *ngIf="filters.unitIds.length > 0">
        ({{filters.unitIds.length}} selected)
    </ng-container>
    <mat-icon *ngIf="expanded" class="adjust">keyboard_arrow_down</mat-icon>
    <mat-icon *ngIf="!expanded" class="adjust">keyboard_arrow_up</mat-icon>
</label>
<div [hidden]="!expanded" class="row">
    <div class="col-lg-12 d-flex justify-content-between">
        <lf-unit-selector
            (onSelect)="updateModel($event)"
            [preselectedUnitIds]="filters.unitIds"
            [isShowingBalances]="true"
            [isShowingPastDue]="true"
        ></lf-unit-selector>
    </div>
</div>
